const loading = {};
export function loadScript(src) {
    if (loading[src] === true) {
        return Promise.resolve();
    }
    if (Array.isArray(loading[src])) {
        return new Promise((resolve) => loading[src].push(resolve));
    }
    loading[src] = [];
    return new Promise((resolve, reject) => {
        const loaded = () => {
            resolve();
            loading[src].forEach((fn) => fn());
            loading[src] = true;
        };
        const failed = () => {
            delete loading[src];
            reject(new Error(`Failed to load script: ${src}`));
        };
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = loaded;
        script.onerror = failed;
        document.body.appendChild(script);
    });
}
